<template>
  <div class="download">
    <div class="logo">
      <img src="../../../assets/images/download/logo.png" alt="" srcset="">
    </div>
    <!-- <div class="title">
      <p>打开货车定位APP或微信小程序</p>
      <p>进入个人中心兑换</p>
    </div> -->
    <div class="tip-img">
      <img src="../../../assets/images/download/tips.png" alt="" srcset="">
    </div>
    <div class="banner">
      <img src="../../../assets/images/download/banber.png" alt="" srcset="">
    </div>
    <div class="btn" @click="goDownload">下载APP</div>

  </div>
</template>

<script>
import { createClickStatistics } from '../../../api/searchCar'
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  components: {},
  async created() {
    await createClickStatistics({type: 77, value: 1})
  },
  mounted() {},
  watch: {},
  methods: {
    async goDownload () {
      await createClickStatistics({type: 78, value: 1})
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.hgj.truckposition'
    }
  }
};
</script>

<style scoped lang="scss">
.download {
  overflow: hidden;
  padding-top: 60px;
  .logo {
    text-align: center;
    padding-bottom: 20px;
    img {
      width: 160px;
    }
  }
  .title {
    text-align: center;
    font-size: 30px;
    color: #353535;
    font-weight: 500;
  }
  .banner {
    margin: 0 auto;
    padding-top: 120px;
    width: 90%;
    img {
      width: 100%;
      // width: 658px;
    }
  }
  .btn {
    background-color: #FF7200;
    border-radius: 46px;
    width: 508px;
    height: 91px;
    text-align: center;
    line-height: 91px;
    font-size: 36px;
    color: #ffffff;
    margin: 0 auto;
    margin-top: 220px;
    margin-bottom: 60px;
  }
  .tip-img {
    width: 474px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
</style>
